var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.9996H11.71L11.43 10.7296C12.63 9.32965 13.25 7.41965 12.91 5.38965C12.44 2.60965 10.12 0.389649 7.32001 0.049649C3.09001 -0.470351 -0.469985 3.08965 0.0500152 7.31965C0.390015 10.1196 2.61002 12.4396 5.39002 12.9096C7.42002 13.2496 9.33002 12.6296 10.73 11.4296L11 11.7096V12.4996L15.25 16.7496C15.66 17.1596 16.33 17.1596 16.74 16.7496C17.15 16.3396 17.15 15.6696 16.74 15.2596L12.5 10.9996ZM6.50002 10.9996C4.01002 10.9996 2.00002 8.98965 2.00002 6.49965C2.00002 4.00965 4.01002 1.99965 6.50002 1.99965C8.99002 1.99965 11 4.00965 11 6.49965C11 8.98965 8.99002 10.9996 6.50002 10.9996Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fbc404a33e05812e4f7f387678d5b70a.svg";
export { ForwardRef as ReactComponent };